<template>
  <section>
    <div class="flex space-x-2 items-center justify-center">
      <ToolIcon :slug="tool.slug" class="w-12" />
      <h1 class="font-bold text-xl lg:text-3xl text-center">Online {{ tool.name }}</h1>
    </div>
    <p class="mt-4 text-center max-w-xl mx-auto">{{ tool.description }}</p>
  </section>
</template>

<script setup lang="ts">
  import ToolIcon from '&/ToolIcon.vue'

  defineProps<{
    tool: object
  }>()
</script>
